import { TreeNode, TreeNodeIdTypes } from 'store/graphs/types';

function getTreeById(metricsTree: TreeNode, id: TreeNodeIdTypes) {
  return metricsTree?.children && metricsTree.children.find(ch => ch.entity.type === 'Tree' && ch.entity.id === id);
}

export default getTreeById;
